export default __webpack_public_path__ + "static/media/logo.9b96875e.svg";